<!-- eslint-disable vue/return-in-computed-property -->
<script setup>
import { RichTextRenderer } from '@marvr/storyblok-rich-text-vue-renderer'

const props = defineProps({ card: Array, color: String, isVisible: Boolean })

const colorClasses = computed(() => {
  switch (props.color) {
    case 'sustainable':
      return 'border border-slate-300 text-primary'
    case 'blue':
      return 'bg-blue-500'
    case 'green':
      return 'bg-green-500'
    case 'primary' :
      return 'bg-primary'
  }
})

const textColorClasses = computed(() => {
  switch (props.color) {
    case 'sustainable':
      return 'text-green'
    case 'blue':
      return 'text-blue-300'
    case 'green':
      return 'text-green-300'
    case 'primary' :
      return 'text-secondary-red-100'
  }
})

const btnClasses = computed(() => {
  switch (props.color) {
    case 'blue':
      return 'bg-blue-400 text-white'
    case 'green':
      return 'bg-green-400 text-white'
    case 'primary' :
      return 'bg-secondary-red-100 text-white'
  }
})

const myClass = ref('')
const activeIndex = ref(0)

function mouseHover(index) {
  activeIndex.value = index
  myClass.value = '!transition-all !duration-300 !ease-in-out !delay-0'
}

function mouseOut() {
  myClass.value = ''
}
</script>

<template>
  <div class="grid gap-6">
    <div
      v-for="(item, index) in card" :key="index"
      class="transition-[transform,opacity] transition-[transform,opacity] relative flex flex-col overflow-hidden rounded-lg px-6 pb-8 pt-7 duration-300 duration-300 ease-in-out"
      :class="[
        index === activeIndex ? ['shadow-custom-xl shadow-shadow-light/10', colorClasses] : ['bg-white', color === 'sustainable' ? colorClasses : ''], myClass,
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[-15px]',
        index === activeIndex && color === 'sustainable' ? '!border-green' : '',
      ]"
      :style="{
        transitionDelay: `${300 * (index + 1)}ms`,
      }"
      @mousemove="mouseHover(index)"
      @mouseleave="mouseOut"
    >
      <div :class="index === activeIndex && color !== 'sustainable' ? 'opacity-100' : 'opacity-0'" class="absolute bottom-0 right-0 min-h-[200px] min-w-[200px] origin-center">
        <DecorlationRstriped :current-color="textColorClasses" class="absolute bottom-0 right-0 z-0 h-full w-auto origin-center translate-x-0" />
      </div>
      <div class="relative mb-custom-md" :class="[color === 'sustainable' ? '!mb-3' : '']">
        <div class="flex flex-col gap-4">
          <div
            v-if="item.icon"
            :class="[activeIndex === index ? '[&>svg>*]:!fill-white text-white' : `text-primary [&>svg]:text-primary`, item.center ? 'mx-auto' : '']"
            class="h-11 w-11"
            v-html="item.icon"
          />
          <h3 :class="[index === activeIndex ? 'text-white' : 'text-primary', color === 'sustainable' ? 'text-green-600' : '']" class="text-lg font-bold lg:text-2xl md:text-xl">
            {{ item.title }}
          </h3>
        </div>
      </div>
      <p v-if="item.subtitle" :class="index === activeIndex ? 'text-white' : 'text-primary'" class="relative mb-custom-lg text-md leading-7">
        {{ item.subtitle }}
      </p>
      <div v-if="item.content" :class="index === activeIndex ? '[&>ul>li>*]:!text-white' : '[&>ul>li>p]:!text-primary'" class="article [&>ul>li]:!mb-0">
        <RichTextRenderer :document="item.content" />
      </div>
      <ul v-if="item.actions.length" class="mt-auto min-h-[45px] flex p-0">
        <li v-for="action in item.actions" :key="action.uuid" :class="activeIndex === index ? 'translate-y-0' : '-translate-y-3'" class="mb-0 max-w-[175px] transition-all duration-200 ease-linear">
          <NuxtLink
            :class="
              index === activeIndex && color === 'green' || index === activeIndex && color === 'primary' || index === activeIndex && color === 'blue' ? btnClasses : 'bg-transparent text-primary [&>svg]:text-primary'
            "
            class="flex items-center rounded-md px-4 py-3 font-bold"
            :to="localePath({
              path: rootedPath(action.link.url ? action.link.url : action.link.cached_url),
            })"
          >
            <span class="mr-2">{{ $t('button.explore') }}</span>
            <svg class="text-white" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M8.59 16.59L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.41z" /></svg>
          </NuxtLink>
        </li>
      </ul>
    </div>
  </div>
</template>
